require("!!/Users/stefania/Projects/onfido/onfido-sdk-ui/node_modules/script-loader/addScript.js")(require("!!/Users/stefania/Projects/onfido/onfido-sdk-ui/node_modules/raw-loader/index.js!/Users/stefania/Projects/onfido/onfido-sdk-ui/node_modules/wpt/wpt.min.js"))


//////////////////
// WEBPACK FOOTER
// ../~/script-loader!../~/wpt/wpt.min.js
// module id = 388
// module chunks = 1